import { Construtor } from './construtor';
import { StringValidacao } from './string';

export class Setor implements Construtor<Setor> {

    public idSetor: number;
    public nomeSetor: string;
    public siglaSetor: string;
    public selecionado: boolean;

    constructor(object?: any) {

        this.selecionado = false;

        if (object !== undefined) {

            if (object instanceof (Setor)) {
                this.copyObject(object);
            } else {
                this.parseFromJson(object);
            }

            if (!this.modeloCompleto()) {
                return null;
            }
        }
    }

    set IdSetor(idSetor: any) {
        this.idSetor = idSetor;
    }

    set NomeSetor(nomeSetor: any) {
        this.nomeSetor = StringValidacao.copiarStringValida(nomeSetor);
    }

    set SiglaSetor(siglaSetor: any) {
        this.siglaSetor = StringValidacao.copiarStringValida(siglaSetor);
    }

    parseFromJson(object: any): void {
        this.idSetor = object.idSetor;
        this.NomeSetor = object.nomeSetor;
        this.SiglaSetor = object.siglaSetor;
    }

    copyObject(setor: Setor): void {
        this.idSetor = setor.idSetor;
        this.NomeSetor = setor.nomeSetor;
        this.SiglaSetor = setor.siglaSetor;
    }

    modeloCompleto(): boolean {
        return this.nomeSetor !== undefined &&
            this.siglaSetor !== undefined;
    }

    getNewInstance(object?: any): Setor {
        return new Setor(object);
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/setor.ts